import { render, staticRenderFns } from "./LeadBoardColumnFooter.vue?vue&type=template&id=1b00a926&"
import script from "./LeadBoardColumnFooter.vue?vue&type=script&lang=js&"
export * from "./LeadBoardColumnFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports